<template>
    <div class="r-c-top">
        <div class="form-list">
            <el-form :model="{}">
                <el-form-item v-for="item in formBase" :key="item.id" :label="item.label">
                    <span>{{ switchFn(item.id, carrierDetail[item.id]) }}</span>
                    <i v-if="showPonit(item.id)" :title="$t('integration.view_tracks')" class="iconfont icon-biaodian"
                        @click="traceInfo(carrierDetail.id)"></i>
                </el-form-item>
            </el-form>
        </div>
        <div class="upload">
            <img :src="carrierDetail.carrierExtend && carrierDetail.carrierExtend.pictureBase64" alt="" srcset="" />
            <el-tooltip v-for="item in pointArray" :key="item.carrierDeviceName" class="item" effect="dark"
                placement="right">
                <div slot="content" class="tip">
                    编号：{{ item.carrierDeviceName }}
                    <template v-if="item.deviceCatalog === 0 && item.probeValue">
                        <p v-if="item.probeValue.temp">
                            <span>温度采集值：{{ item.probeValue.temp.val }}{{ unit['temp'].name }}</span>
                            <span>温度采集时间：{{ $timetransition(item.probeValue.temp.time) }}</span>
                        </p>
                        <p v-if="item.probeValue.hum">
                            <span>湿度采集值：{{ item.probeValue.hum.val }}{{ unit['hum'].name }}</span>
                            <span>湿度采集时间：{{ $timetransition(item.probeValue.hum.time) }}</span>
                        </p>
                        <p v-if="item.probeValue.batt">
                            <span>电压采集值：{{ item.probeValue.batt.val }}V</span>
                            <span>电压采集时间：{{ $timetransition(item.probeValue.batt.time) }}</span>
                        </p>
                        <p v-if="item.probeValue.rssi">
                            <span>RSSI采集值：{{ item.probeValue.rssi.val }}rssi(dBm)</span>
                            <span>RSSI采集时间：{{ $timetransition(item.probeValue.rssi.time) }}</span>
                        </p>
                        <p v-if="item.probeValue.lqi">
                            <span>LQI采集值：{{ item.probeValue.lqi.val }}</span>
                            <span>LQI采集时间：{{ $timetransition(item.probeValue.lqi.time) }}</span>
                        </p>
                        <p>
                            <span>温度监测区间：{{ item.minTemp || '--' }}{{ unit['temp'].name }} ~ {{ item.maxTemp || '--' }}{{
                                unit['temp'].name }}</span>
                            <span>湿度监测区间：{{ item.minHum || '--' }}{{ unit['hum'].name }} ~ {{ item.maxHum || '--' }}{{
                                unit['hum'].name }}</span>
                        </p>
                    </template>
                </div>
                <i v-if="item.xpos && item.xpos !== 0" v-icon="['equiTypeConvert', item.deviceCatalog]" :style="{
                    position: 'absolute',
                    left: item.xpos * rate + 'px',
                    top: item.ypos * rate + 'px'
                }"></i>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import { carrierTypeConvert, carrierStatusConvert, isAbnormalConvert, traceConvert, isAlarmConvert } from '@/utils/convert.js';

import { traceInfo } from '@/utils/winDetail';

export default {
    props: ['carrierDetail'],
    watch: {
        carrierDetail(newVal) {
            console.log(newVal);
            this.handleImg((newVal.carrierExtend && newVal.carrierExtend.pictureBase64) || '');
            this.pointArray = [];
            let merged = [];
            // let obj = newVal.carrierPosition || {};
            // let objDevice = newVal.carrierDevice || {};
            // const { displayList, gatewayList, relayList, sensorList } = newVal.carrierDevice;
            // const { displayPositionList, gatewayPositionList, relayPositionList, sensorPositionList } = newVal.carrierPosition;
            // merged = linkField(sensorList, sensorPositionList, 'id', 'sensor_id', function() {
            //     this.typeId = 0;
            //     this.name = this.tagId;
            //     if (this.probeValue !== '' && this.probeValue) {
            //         this.probeValue = JSON.parse(this.probeValue);
            //     }
            // });
            // merged = mapDeserialize(merged);
            // this.pointArray = this.pointArray.concat(merged);
            // merged = linkField(gatewayList, gatewayPositionList, 'id', 'gateway_id', function() {
            //     this.typeId = 1;
            // });
            // merged = mapDeserialize(merged);
            // this.pointArray = this.pointArray.concat(merged);
            // merged = linkField(displayList, displayPositionList, 'id', 'display_id', function() {
            //     this.typeId = 2;
            // });
            // merged = mapDeserialize(merged);
            // this.pointArray = this.pointArray.concat(merged);
            // merged = linkField(relayList, relayPositionList, 'id', 'relay_id', function() {
            //     (this.typeId = 3), (this.name = this.relay_code);
            // });
            // merged = mapDeserialize(merged);
            // this.pointArray = this.pointArray.concat(merged);
            // console.log(this.pointArray);
            this.pointArray = newVal.carrierDevice.deviceList.map(item => {
                if (item.probeValue === 'string')
                    item.probeValue = JSON.parse(item.probeValue);
                return item;

            });
        }
    },
    data() {
        return {
            traceInfo,
            formBase: [
                {
                    id: 'fullPath',
                    label: $t('integration.belonging_to')
                },
                {
                    id: 'keycode',
                    label: $t('integration.name_of_monitoring_point')
                },
                {
                    id: 'typeId',
                    label: $t('integration.type')
                },
                {
                    id: 'status',
                    label: $t('integration.state')
                },
                {
                    id: 'abnormal',
                    label: this.$t('business.curAbnormal')
                },
                {
                    id: 'isTrace',
                    label: $t('integration.traceable')
                },
                {
                    id: 'alarmSwitch',
                    label: $t('integration.alarm_on')
                },
                {
                    id: 'tag',
                    label: $t('integration.label')
                },
                {
                    id: 'description',
                    label: $t('integration.describe')
                }
            ],
            carrierTypeConvert,
            carrierStatusConvert,
            isAbnormalConvert,
            traceConvert,
            isAlarmConvert,
            rate: 1,
            pointArray: []
        };
    },
    methods: {
        showPonit(id) {
            return id === 'isTrace' && this.carrierDetail[id] === 1;
        },
        switchFn(id, value) {
            if (value || value === 0) {
                switch (id) {
                    case 'typeId': {
                        return this.$t(carrierTypeConvert(value).title);
                    }
                    case 'status': {
                        return this.$t(carrierStatusConvert(value).title);
                    }
                    case 'abnormal': {
                        return value === 1 ? $t('integration.yes') : $t('integration.no');
                    }
                    case 'isTrace': {
                        return this.$t(traceConvert(value).title);
                    }
                    case 'alarmSwitch': {
                        return this.$t(isAlarmConvert(value).title);
                    }
                    default:
                        return value;
                }
            }
        },
        //用于处理图片缩放比的计算 与锚点
        handleImg(picture) {
            if (!picture) return (this.rate = 0.1);
            // 获取图片的宽度  进而得到图片被压缩成400px后的缩放比  以后每次锚点计算 都要乘上这个缩放比
            const img = new Image();

            img.src = picture;

            // 避免图片没回来时硬刷新坐标错位问题
            img.onload = () => {
                // 获取图片的缩放比 每次计算锚点都需要乘上这个比例
                if (img.width > img.height) {
                    this.rate = 200 / img.width;
                } else {
                    this.rate = 200 / img.height;
                }
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.r-c-top {
    min-height: 279px;
    border-bottom: 1px solid #ccc;
    display: flex;
    overflow: auto;

    .form-list {
        flex: 1;
        padding-top: 6px;
        padding-left: 15px;
        box-sizing: border-box;

        i {
            margin-left: 5px;
            cursor: pointer;
        }

        ::v-deep .el-form-item--mini.el-form-item {
            margin-bottom: 2px !important;
        }
    }

    .upload {
        width: 200px;
        height: 200px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        margin: 3% 3% 0 0;
        position: relative;

        img {
            display: block;
            width: 100%;
            height: 100%;
        }

        .icon {
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
        }
    }
}

.tip {
    p {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;

        span {
            margin-right: 15px;
        }
    }
}
</style>
